/**
 * Main site initialization and utilities
 * Handles scrollbar width calculation, phone formatting, and carousel initialization
 */

// =============================================================================
// PHONE FORMATTER
// =============================================================================

/**
 * Initialize phone formatting for all elements with 'avochato-number' ID
 */
const initPhoneFormatter = () => {
  /**
   * Format phone number input to (XXX) XXX-XXXX pattern
   * @param {Event} event - Input event from phone number field
   */
  const formatPhoneNumber = function(event) {
    // Remove all non-digit characters
    let input = this.value.replace(/\D/g, '');
    
    // Apply formatting pattern
    let formattedInput = '';
    for (let i = 0; i < input.length; i++) {
      if (i === 0) {
        formattedInput += "(" + input[i];
      } else if (i === 3) {
        formattedInput += ") " + input[i];
      } else if (i === 6) {
        formattedInput += "-" + input[i];
      } else {
        formattedInput += input[i];
      }
    }
    
    // Update input value
    this.value = formattedInput;
  };

  const phoneInputs = document.querySelectorAll('#avochato-number');
  phoneInputs.forEach(input => {
    input.addEventListener('input', formatPhoneNumber);
  });
};

// =============================================================================
// CAROUSELS
// =============================================================================

/**
 * Initialize all carousel types
 */
const initCarousels = () => {
  /**
   * Initialize full screen slides carousel
   * Responsive carousel that shows 1 slide on mobile, 3 on desktop
   */
  const initFullScreenSlides = () => {
    $('.scroll-container').slick({
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      slidesToShow: 1,
      mobileFirst: true,
      dots: false,
      fade: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
            fade: false,
            accessibility: false
          }
        }
      ]
    });
  };

  /**
   * Initialize fade transition carousel
   * Simple fade-in/out carousel with auto-play
   */
  const initFadeCarousel = () => {
    $('.slick-fade').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
    });
  };

  /**
   * Initialize news carousel
   * Multi-slide carousel for news content with responsive breakpoints
   */
  const initNewsCarousel = () => {
    $('.news-slick').slick({
      autoplay: true,
      dots: true,
      centered: true,
      accessibility: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            accessibility: false
          }
        }
      ]
    });
  };

  // Initialize all carousel types
  initFullScreenSlides();
  initFadeCarousel();
  initNewsCarousel();
};

const initCarousels2 = () => {
  /**
   * Initialize full screen slides carousel
   * Responsive carousel that shows 1 slide on mobile, 3 on desktop
   */
  const initFullScreenSlides2 = () => {
    $('.scroll-container').slick({
      autoplay: true,
      autoplaySpeed: 1500,
      arrows: false,
      slidesToShow: 1,
      mobileFirst: true,
      dots: false,
      fade: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            fade: false,
            accessibility: false
          }
        }
      ]
    });
  };

  /**
   * Initialize fade transition carousel
   * Simple fade-in/out carousel with auto-play
   */
  const initFadeCarousel2 = () => {
    $('.slick-fade').slick({
      autoplay: true,
      arrows: false,
      dots: false,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear',
    });
  };

  /**
   * Initialize news carousel
   * Multi-slide carousel for news content with responsive breakpoints
   */
  const initNewsCarousel2 = () => {
    $('.news-slick2').slick({
      autoplay: true,
      dots: true,
      centered: true,
      accessibility: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            accessibility: false
          }
        }
      ]
    });
  };

  // Initialize all carousel types
  initFullScreenSlides2();
  initFadeCarousel2();
  initNewsCarousel2();
};

// =============================================================================
// AVOCHATO FORMS
// =============================================================================

/**
 * Initialize Avochato form submission handling
 */
const initAvochatoForms = () => {
  /**
   * Handle form submission with API request
   * @param {Event} event - Form submit event
   */
  const handleFormSubmit = function(event) {
    event.preventDefault();
    
    console.log('📝 Avochato form submitted');
    
    const request = new XMLHttpRequest();
    request.open("POST", 'https://events.hookdeck.com/e/src_0TAQ1mB5C99j');
    request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    
    request.onreadystatechange = function() {
      if (this.readyState === 4) {
        if (this.status === 200) {
          console.log('✅ Form submitted successfully');
          
          // Show success message
          const successMessage = event.target.querySelector(".form-success");
          if (successMessage) {
            successMessage.style.display = "block";
          }
          
          // Clear phone number field
          const phoneField = event.target.querySelector(".avochato-number");
          if (phoneField) {
            phoneField.value = "";
            console.log('🧹 Phone field cleared');
          }
          
        } else {
          console.log('❌ Form submission failed', {
            readyState: this.readyState,
            status: this.status
          });
          const errorMessage = event.target.querySelector(".form-error");
          if (errorMessage) {
            errorMessage.style.display = "block";
          }
        }
      }
    };
    
    // Get form data
    const phoneValue = event.target.querySelector(".avochato-number")?.value;
    const secretShopKeywordValue = event.target.querySelector(".avochato-secret-shop-keyword")?.value || false;
    
    console.log('📤 Sending data:', { phone: phoneValue, secret_shop_keyword: secretShopKeywordValue });
    
    // Send request
    request.send(JSON.stringify({
      phone: phoneValue,
      secret_shop_keyword: secretShopKeywordValue
    }));
  };

  // Wait for potential dynamic content to load
  setTimeout(() => {
    const avochatoForms = document.querySelectorAll('.avochato-form');
    console.log(`🔍 Found ${avochatoForms.length} Avochato forms`);
    
    avochatoForms.forEach((form, index) => {
      console.log(`🎯 Initializing form ${index + 1}`);
      form.addEventListener("submit", handleFormSubmit);
    });
  }, 1000);
};

// =============================================================================
// SITE INITIALIZATION
// =============================================================================

/**
 * Initialize all site components when DOM is ready
 */
const initSite = () => {
  
  // Initialize form utilities
  initPhoneFormatter();
  
  // Initialize carousels
  initCarousels();

  initAvochatoForms();

  initCarousels2();

};

// Initialize site when DOM is ready
document.addEventListener('DOMContentLoaded', initSite);